module.exports = {"id":"dp4_3l1q6","text":"Supporting Wellbeing","instructions":"There are laws and regulations designed to protect individuals' wellbeing in digital environments.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.3","questionType":"PickOne","random":false,"options":[{"id":"dp4_3l1q6-a1","text":"True","score":1.8},{"id":"dp4_3l1q6-a2","text":"Not sure","score":0},{"id":"dp4_3l1q6-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.3/l1q6.json
// module id = 1249
// module chunks = 41